import React, { useEffect, useRef, useState } from "react";
import {
  Paper,
  Typography,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Stack,
  Button,
  TextField,
  Checkbox,
  FormControlLabel,
  Radio,
  Tooltip,
} from "@mui/material";
import Grid from "@material-ui/core/Grid";
import Toggle from "@atlaskit/toggle";
import {
  filterString,
  makePassword,
  NotificationType,
  PaymentPages,
  RoomCategory,
  RoomDuration,
  RoomOccurenceType,
  RoomOccurenceWeekDays,
  WeekNumber,
  WeekDayNames,
  MonthType,
} from "../Utils";
import {
  createRoom,
  getMyContactGroup,
  getMySubscription,
  getRoomList,
  updateRoom,
} from "../../../paymentRequest";
import DatePicker from "react-datepicker";
import {
  hideApiLoader,
  setUserLoginData,
  showApiLoader,
} from "../../../../redux/tool-webjam/actions";
import { useDispatch, useSelector } from "react-redux";
import {
  setNotificationMessage,
  setPaymentSelectedPage,
  setWindowReference,
} from "../payment-reducer/actions";
import {
  FEATURE_CUSTOM_PAYMENT,
  FEATURE_CUSTOM_REDUX,
  FEATURE_CUSTOM_REDUX_V2,
} from "../../../../constant";
import { messages } from "../messages";
import { isEmpty } from "lodash";
import { messages as dashboardMessages, stripeMessage } from "../../../messages";
import { getLJsonStorage, startsWithNumber, usePrevious, useDevice } from "../../../Utils";
import {
  RenderRecurrenceType,
  DropDownOptions,
  RenderRecurrenceMDays,
  formatDate,
} from "../AbstractHelperComponent";
import "./room.css";
import PaymentAccountModal from "../../../../explore/PaymentAccountModal";
import { connectAccountFlag, getBaseConfig, handlePaymentWindow } from "../../../../Utils";
import {
  setStripeRequesting,
} from "../../../../redux/tool-webjam-v2/actions";
import { createConnectLink } from "../../../Request.d";
import { v4 as uuidv4 } from "uuid";
import { socketOn } from "../../../../../../../socket";
import { copyText } from "../../../../../base/util/copyText.web";
import { Constant } from "../../../../../webjam/constant";
import toast from "react-simple-toasts";
import { checkSubscription, ct, localeCalender } from "../../../../constant-Utils";
import { dynamicMessageLocale } from "../../../../constant-Utils";
import ConfirmationAlert from "../ConfirmationAlert";
import PackageList from "../PackageList";

let css = `.pay-dash-cont input {
    width:100% !important;
    height:40px !important;
    margin:0 !important;
}`;

let welcomeCss = document.createElement("style");
welcomeCss.type = "text/css";
welcomeCss.appendChild(document.createTextNode(css));

document.getElementsByTagName("head")[0].appendChild(welcomeCss);

const CreateRoom = (props) => {
  const defaultFormValue = {
    room_name: "",
    private: false,
    password: "",
    category: "",
    publish: false,
    endDate: "",
    paid: false,
    room_amount: "",
    startDate: "",
    invited_users: {
      email_id: [],
      group_id: "",
    },
    recurring: false,
    timezone: "",
    recurrence_type: RoomOccurenceType.DAILY,
    recurrence_interval: 1,
    week_occurence: {},
    month_occurence: {
      day: 0,
      week_days: {
        [WeekNumber.FIRST]: WeekDayNames.MONDAY,
      },
    },
    month_type: MonthType.ONCE,
  };

  const paidRef = useRef();
  const eDateRef = useRef();

  const [formValue, setFormValue] = useState(defaultFormValue);
  const [errors, setErrors] = useState({
    room_name: "",
    category: "",
    endDate: "",
    startDate: "",
  });

  const [durationMin, setDurationMin] = useState([0, 15, 30, 45]);
  const [durationHrs, setDurationHrs] = useState([]);
  const [groupList, setGroupList] = useState([]);
  const [isEndDateShrink, setIsEndDateShrink] = useState(false);
  const [isStartDateShrink, setIsStartDateShrink] = useState(false);
  const [isEndDateFocus, setIsEndDateFocus] = useState(false);
  const [isStartDateFocus, setIsStartDateFocus] = useState(false);
  const [connectAccount, setConnectAccount] = useState(false);
  const [connectAccountVerified, setConnectAccountVerified] = useState("");
  const [existingUser, setExistingUser] = useState([]);
  const [showAccountModal, setShowAccountModal] = useState(false);
  const [connectApprovedFlash, setConnectApprovedFlash] = useState(false);
  const [stripeSessionId, setStripeSessionId] = useState("");
  const [isSubscriptionRequired, setIsSubscriptionRequired] = useState(false);
  const [openSubscriptionModal, setOpenSubscriptionModal] = useState(false);
  const [showApplyCouponModal, setShowApplyCouponModal] = useState(false);

  const dispatch = useDispatch();

  const { paymentId, timezones, userPaymentSubscription } = useSelector(
    (state) => state[FEATURE_CUSTOM_PAYMENT]
  );

  const { userLoginData } = useSelector((state) => state[FEATURE_CUSTOM_REDUX]);
  const { clickedAutoMakeHost } = useSelector((state) => state[FEATURE_CUSTOM_REDUX]);

  const {
    isStripeConnect,
    isStripeConnectVerified,
    isStripeRequesting,
    authOrganization
  } = useSelector((state) => state[FEATURE_CUSTOM_REDUX_V2]);


  const handleOnFocusDate = (type, action) => {
    if (type === "endDate" && action === "onFocus") {
      setIsEndDateShrink(true);
      setIsEndDateFocus(true);
    } else {
      setIsEndDateFocus(false);
    }

    if (type === "endDate" && action === "onBlur" && !formValue.endDate) {
      setIsEndDateShrink(false);
    }

    if (type === "startDate" && action === "onFocus") {
      setIsStartDateShrink(true);
      setIsStartDateFocus(true);
    } else {
      setIsStartDateFocus(false);
    }

    if (type === "startDate" && action === "onBlur" && !formValue.startDate) {
      setIsStartDateShrink(false);
    }
  };

  const { isMobile, isTablet } = useDevice();

  const getTranslatedInterval = (interval) => {
    return ct("rta-trmc.dashboard.subscription." + interval)
  }

  useEffect(() => {
    // fetchContactGroup();
    if (paymentId) {
      dispatch(showApiLoader());
      getRoomList({
        room_id: paymentId,
      })
        .then((res) => {
          if (res.status == 1) {
            let data = res.data?.data;

            // let invited_users = {
            //     email_id: [],
            //     group_id: ''
            // }

            // let allEmails = [];
            // if (data.contact_list?.length) {
            //     data.contact_list.map(e => {
            //         if (e.contact_id) {
            //             if (e.group == undefined) {
            //                 allEmails.push({
            //                     name: "",
            //                     _id: e.contact_id,
            //                     email: e.email
            //                 })
            //                 invited_users.email_id.push(e.contact_id)
            //             } else if (e.group != undefined) {
            //                 console.log("contact user group ", e.group)
            //                 invited_users.group_id = e.group?._id;
            //             }
            //         }
            //     })
            // }

            let initData = {
              room_name: data.groupName,
              private: data.private,
              publish: data.publish,
              password: data.password,
              category: data.category,
              paid: data.paid,
              room_amount: data?.paidDetail?.amount,
              // invited_users
            };

            // console.log("existing emails ", allEmails)
            // if (allEmails.length) {
            //     setExistingUser(allEmails);
            // }
            if (!isEmpty(data.startDate)) {
              initData.startDate = new Date(data.startDate);
            }

            if (!isEmpty(data.endDate)) {
              initData.endDate = new Date(data.endDate);
            }
            if (data.paid) {

              if (data.roomAmt) {
                initData.room_amount = data.roomAmt;
              }
            }

            initData.timezone = data.timezone;
            if (data?.recurring) {
              initData.recurring = data.recurring;

              // set interval which is default in every type
              if (data.repeat_daily != undefined) {
                initData.recurrence_interval = data.repeat_daily.interval;
                initData.recurrence_type = RoomOccurenceType.DAILY;
              } else if (data.repeat_weekly != undefined) {
                initData.recurrence_interval = data.repeat_weekly.interval;
                initData.week_occurence = data.repeat_weekly.week_occurence;
                // set user selected week days
                initData.recurrence_type = RoomOccurenceType.WEEKLY;
              } else if (data.repeat_monthly != undefined) {
                initData.recurrence_type = RoomOccurenceType.MONTHLY;
                initData.recurrence_interval = data.repeat_monthly.interval;
                initData.month_occurence = {
                  ...formValue.month_occurence,
                };
                // if user select custom week days
                if (data.repeat_monthly.custom_day != undefined) {
                  initData.month_occurence.week_days = {
                    [data.repeat_monthly.custom_day.day_position]:
                      data.repeat_monthly.custom_day.on_day,
                    //week day position i.e first,second..  : week day sun, mon ....
                  };
                  initData.month_type = MonthType.MULTIPLE;
                } else {
                  // if user select month default days
                  initData.month_occurence.day = data.repeat_monthly.month_day;
                  initData.month_type = MonthType.ONCE;
                }
              }
            }
            // if (!isEmpty(data.endDate)) {
            //     initData.endDate = new Date(data.endDate)
            // }
            let setData = {
              ...formValue,
              ...initData,
            };
            setFormValue({ ...setData });
          }
        })
        .finally(() => {
          dispatch(hideApiLoader());
        });
    }
    // } else {
    //     setFormValue(defaultFormValue)
    // }

    // dispatch(getTimezone())

    let setHrs = [];
    for (let i = 0; i < RoomDuration; i++) {
      setHrs.push(i);
    }
    setDurationHrs(setHrs);

    if (userLoginData?.user?.stripe_account_id) {
      setConnectAccount(true);
      if (userLoginData?.user?.connectVerified != "") {
        setConnectAccountVerified(userLoginData?.user?.connectVerified);
      }
    }

    return () => {
      setConnectApprovedFlash(false);
      setConnectAccountVerified("");
    };
  }, []);

  useEffect(() => {
    if (!paymentId) {
      setFormValue(defaultFormValue);
      setExistingUser([]);
    }
  }, [paymentId]);

  useEffect(() => {
    if (isStripeConnect) {
      setConnectAccount(true);
    }
  }, [isStripeConnect]);

  let prevStripeStatus = usePrevious(isStripeConnectVerified);

  useEffect(() => {
    if (prevStripeStatus != isStripeConnectVerified && isStripeRequesting) {
      if (isStripeConnectVerified == connectAccountFlag.APPROVED) {
        if (paidRef != undefined) {
          if (paidRef.current != undefined) {
            setTimeout(function () {
              paidRef.current.click();
            }, 100);
          }
        }

        setTimeout(function () {
          setFormValue({
            ...formValue,
            paid: true,
          });

          setConnectAccount(true);
          setConnectAccountVerified(connectAccountFlag.APPROVED);
          setConnectApprovedFlash(true);
        }, 500);

        dispatch(setStripeRequesting(false));
        setTimeout(function () {
          setConnectApprovedFlash(false);
        }, ct("stripeMessage.successFlushTime", "stripeMessage"));
      } else {
        if (isStripeConnectVerified) {
          setConnectAccountVerified(isStripeConnectVerified);
        }
      }
    }
  }, [isStripeConnectVerified]);

  const handleInput = (e) => {
    const { name, value } = e.target;
    let defaultInput = {};
    if (name == "private") {
      if (e.target.checked) {
        defaultInput.private = true;
        defaultInput.password = makePassword();
      } else {
        defaultInput.private = false;
        defaultInput.password = "";
      }
    } else if (name == "publish") {
      if (e.target.checked) {
        defaultInput.publish = true;
      } else {
        defaultInput.publish = false;
        defaultInput.category = "";
      }
    } else if (name == "paid") {
      if (e.target.checked) {
        defaultInput.paid = true;
      } else {
        defaultInput.room_amount = "";
        defaultInput.paid = false;
      }
    } else if (
      name == "category" ||
      name == "room_name" ||
      name == "timezone" ||
      name == "room_amount"
    ) {
      if (name == "room_name") {
        const r = value.replace(/ /g, "")
        defaultInput[name] = (r.toLowerCase()).trim();
      } else {
        defaultInput[name] = value;
      }
    } else if (name == "contact_group") {
      if (defaultInput.invited_users == undefined) {
        defaultInput.invited_users = {
          email_id: [],
          group_id: "",
        };
      }
      defaultInput.invited_users.group_id = value;
    }

    setFormValue({
      ...formValue,
      ...defaultInput,
    });
  };

  const selectedEmail = (data) => {

    let defaultInput = formValue;
    // let ids = Object.values(data);
    let ids = data.map((e) => e._id);

    let group_id = formValue.invited_users.group_id;
    delete defaultInput.invited_users;

    defaultInput = {
      ...defaultInput,
      invited_users: {
        group_id,
        email_id: ids,
      },
    };
    setFormValue(defaultInput);
  };

  const fetchContactGroup = (data = {}, pagination = "?page=1&limit=100") => {
    getMyContactGroup(data, pagination).then((res) => {
      if (res.status == 1) {
        let data = res.data.data;
        if (data.group.length) {
          setGroupList(data.group);
        }
      }
    });
  };

  const handleChangeDate = (date) => {
    let defaultInput = formValue;
    defaultInput = {
      ...defaultInput,
      ...date,
    };
    setFormValue(defaultInput);
  };

  const handleFormSubmit = () => {
    let willProcess = true;

    let errorList = {};

    if (!formValue.room_name.length) {
      errorList = Object.assign(
        {
          room_name: ct("stripeMessage.roomName", "stripeMessage")
        },
        errorList
      );

      willProcess = false;
    }

    if (formValue.room_name.length < 3) {
      if (willProcess) {
        errorList = Object.assign(
          {
            room_name: ct("messages.inviteNameLength", "messages")
          },
          errorList
        );

        willProcess = false;
      }
    }

    if (formValue.room_name.length > 25) {
      if (willProcess) {
        errorList = Object.assign(
          {
            room_name: ct("messages.invalidRoomLength", "messages")
          },
          errorList
        );

        willProcess = false;
      }
    }

    if (formValue.publish) {
      if (!formValue.category.length) {
        errorList = Object.assign(
          {
            category: ct("stripeMessage.category", "stripeMessage"),
          },
          errorList
        );
        willProcess = false;
      }
    }

    let amount = formValue.room_amount;

    if (formValue.endDate && !formValue.startDate) {
      errorList = Object.assign(
        {
          startDate: ct("stripeMessage.startDate", "stripeMessage"),
        },
        errorList
      );
      willProcess = false;
    }
    if (formValue.endDate && formValue.endDate < formValue.startDate) {
      errorList = Object.assign(
        {
          endDate: ct("stripeMessage.endDateLess", "stripeMessage"),
        },
        errorList
      );
      willProcess = false;
    }

    if (formValue.paid) {

      // if (!formValue.endDate) {
      //   errorList = Object.assign(
      //     {
      //       endDate: stripeMessage.endDate,
      //     },
      //     errorList
      //   );

      //   willProcess = false;
      // }
      if (!amount) {
        errorList = Object.assign(
          {
            room_amount: ct("stripeMessage.roomAmount", "stripeMessage"),
          },
          errorList
        );
        willProcess = false;
      } else if (amount < stripeMessage.roomAmountMin) {
        errorList = Object.assign(
          {
            room_amount: ct("stripeMessage.roomAmountLess", "stripeMessage"),
          },
          errorList
        );
        willProcess = false;
      } else if (amount > stripeMessage.roomAmountMax) {
        errorList = Object.assign(
          {
            room_amount: ct("stripeMessage.roomAmountGreat", "stripeMessage"),
          },
          errorList
        );
        willProcess = false;
      }
    }

    setErrors(errorList);

    let sendPay = {
      ...formValue,
      email: getLJsonStorage("auth", "email"),
    };

    if (sendPay.private == false) {
      sendPay.password = "";
    }
    if (sendPay.publish == false) {
      sendPay.category = "";
    }
    if (sendPay.paid == false) {
      sendPay.room_amount = 0;
    }

    // console.log("authOrganization ",authOrganization )

    let request = "";
    var finalPayload = {
      ...formValue,
      startDate: formValue?.startDate,
      endDate: formValue?.endDate,
      roomAmt: formValue?.paid ? formValue?.room_amount : 0,
      organization_id: authOrganization._id,
      room_amount: formValue?.paid ? formValue?.room_amount : 0,
    };
    // finalPayload = Object.assign({
    //   organization_id: authOrganization._id,
    // },finalPayload)

    // console.log("send payload ",finalPayload)

    // Checking user have subscription to create a new room

    const haveSubscription = checkSubscription();

    if (!haveSubscription && willProcess) {
      setIsSubscriptionRequired(true);
      return false;
    }

    if (willProcess) {
      if (paymentId) {
        request = updateRoom(finalPayload, paymentId);
      } else {
        finalPayload = Object.assign({
          autohost: clickedAutoMakeHost
        }, finalPayload)
        request = createRoom(finalPayload);
      }

      dispatch(showApiLoader());
      request.then(async (res) => {
        dispatch(hideApiLoader());
        if (res.status == 1) {
          let dynamicMessage = await dynamicMessageLocale(res.data.message)
          dispatch(
            setNotificationMessage({
              isOpen: true,
              type: NotificationType.SUCCESS,
              message: dynamicMessage
            })
          );
          // toast(res.data.message);
          dispatch(setPaymentSelectedPage(PaymentPages.HOSTED_ROOM));
        } else {

          setTimeout(async () => {
            let msg = "";
            if (res.data.message != undefined) {
              msg = await dynamicMessageLocale(res.data.message);
            } else {
              msg = ct("rta-trmc.dashboard.subscription.failed");
            }
            dispatch(
              setNotificationMessage({
                isOpen: true,
                type: NotificationType.ERROR,
                message: msg,
              })
            );
          })
        }
      });
    }
  };

  const handleChangeRecurrence = (e) => {
    const { name, value } = e.target;
    if (name == "recurrence_type") {
      let setData = {
        ...formValue,
        recurrence_type: value,
        week_occurence: {},
        recurrence_interval: 1,
      };
      let date = new Date();
      if (value == RoomOccurenceType.WEEKLY) {
        let week = date.getDay();
        setData.week_occurence[RoomOccurenceWeekDays[week]] =
          RoomOccurenceWeekDays[week];
      } else if (value == RoomOccurenceType.MONTHLY) {
        let day = date.getDate();
        setData.month_occurence = {
          ...formValue.month_occurence,
          day,
        };
      }

      setFormValue(setData);
    } else if (name == "recurrence_interval") {
      setFormValue({
        ...formValue,
        recurrence_interval: value,
      });
    } else if (name == "recurrence_m_days") {
      setFormValue({
        ...formValue,
        month_occurence: {
          ...formValue.month_occurence,
          day: value,
        },
      });
    } else if (name == "recurrence_user-days-on") {
      setFormValue({
        ...formValue,
        month_occurence: {
          ...formValue.month_occurence,
          week_days: {
            [value]: filterOnWeek().value,
          },
        },
      });
    } else if (name == "recurrence_user-days-on-week") {
      setFormValue({
        ...formValue,
        month_occurence: {
          ...formValue.month_occurence,
          week_days: {
            [filterOnWeek().key]: value,
          },
        },
      });
    }
  };

  const handleWeekly = (e) => {
    const { name, value } = e.target;

    let occurence = formValue.week_occurence;

    if (occurence[name] == undefined) {
      occurence[name] = name;
    } else {
      delete occurence[name];
    }

    setFormValue({
      ...formValue,
      week_occurence: occurence,
    });
  };

  const handleCheck = (e) => {
    let { name, value } = e.target;

    if (name == "month_days") {
      setFormValue({
        ...formValue,
        month_type: MonthType.ONCE,
      });
    } else {
      setFormValue({
        ...formValue,
        month_type: MonthType.MULTIPLE,
      });
    }
  };

  const filterOnWeek = () => {
    let hasKeys = Object.keys(formValue.month_occurence.week_days);

    let key = "",
      value = "";

    if (hasKeys.length) {
      key = hasKeys[0];
      value = formValue.month_occurence.week_days[key];
    }
    return {
      key,
      value,
    };
  };

  const printRecType = () => {
    let type = formValue.recurrence_type?.toLowerCase();
    if (type == "daily") {
      return ct("rta-trmc.dashboard.myRoom.daysText");
    } else if (type == "weekly") {
      return ct("rta-trmc.dashboard.myRoom.weeksText");
    } else if (type == "monthly") {
      return ct("rta-trmc.dashboard.myRoom.monthsText");
    }
  };

  const closePaymentAccount = () => {
    setShowAccountModal(false);
  };

  const submitPaymentAccount = () => {
    setShowAccountModal(false);
    handlePaidToggle(false);
  };

  const handlePaidToggle = (
    showMessage = true,
    type = "",
    showModal = false
  ) => {
    console.log("check p 1 ", showModal);
    if (showModal == true) {
      setShowAccountModal(true);
      return false;
    }

    let user_id = userLoginData?.user?.id;

    if (connectAccountVerified == connectAccountFlag.PENDING) {
      return false;
    }

    // console.log("check p 3 ", showMessage, type)

    // if (showMessage && type == "update") {
    //   dispatch(setNotificationMessage({
    //     isOpen: true,
    //     type: NotificationType.INFO,
    //     message: stripeMessage.paymentAccountNVerify,
    //   }));
    // } else if (showMessage) {
    //   console.log("check p 4", showMessage, type)

    //   if (showMessage && type == "update") {
    //     dispatch(setNotificationMessage({
    //       isOpen: true,
    //       type: NotificationType.INFO,
    //       message: stripeMessage.paymentAccountRequire,
    //     }));
    //   }

    //   let isEdit = 0;

    //   if (type == "update") {
    //     isEdit = 1;
    //   }
    dispatch(showApiLoader());
    console.log("check p 3 ", connectAccountVerified);

    let popUid = uuidv4();
    dispatch(setStripeRequesting(true));
    console.log("check p 4");

    createConnectLink(user_id, popUid).then((resp) => {
      console.log("check p 5 ", resp);

      dispatch(hideApiLoader());
      if (resp.status == 1) {
        let redir = resp.data?.data?.link;
        if (redir) {
          // var win = window.open(redir, "newwin", "height=800px,width=600px");
          var win = handlePaymentWindow(redir);
          dispatch(
            setWindowReference({
              win,
              uid: popUid,
            })
          );
        } else {
          dispatch(
            setNotificationMessage({
              isOpen: true,
              type: NotificationType.ERROR,
              message: ct("rta-trmc.dashboard.subscription.failed"),
            })
          );
        }
      } else {
        setTimeout(async () => {
          let msg = await dynamicMessageLocale(resp?.message)
          dispatch(
            setNotificationMessage({
              isOpen: true,
              type: NotificationType.ERROR,
              message: msg || ct("rta-trmc.dashboard.subscription.failed"),
            })
          );
        })
      }
    });
  };

  const renderAccountView = () => {
    if (!connectAccount) {
      return (
        <Button
          appearance="primary"
          onClick={() => handlePaidToggle(false)}
          type="button"
          className="submit-button join-meeting-pass  mt-4 paid-lecture-btn"
        >
          {ct("stripeMessage.createConnectAccount", "stripeMessage")}
        </Button>
      );
    } else {
      if (userLoginData?.user?.connectVerified == connectAccountFlag.FAILED) {
        return (
          <Button
            appearance="primary"
            onClick={() => handlePaidToggle(false)}
            type="button"
            className="submit-button join-meeting-pass mt-4 paid-lecture-btn"
          >
            {ct("stripeMessage.updateConnectAccount", "stripeMessage")}
          </Button>
        );
      } else if (userLoginData?.user?.connectVerified == connectAccountFlag.ENABLED) {
        return (
          <Button
            appearance="primary"
            onClick={() => handlePaidToggle(false)}
            type="button"
            className="submit-button join-meeting-pass mt-4 paid-lecture-btn"
          >
            {ct("stripeMessage.updateAdditionalConnectAccount", "stripeMessage")}
          </Button>
        );
      }
    }
    return null;
  };

  const handleBack = () => {
    dispatch(setPaymentSelectedPage(PaymentPages.HOSTED_ROOM));
  };

  const handleSubscriptionDialog = (showApplyCouponModal) => {
    setOpenSubscriptionModal(true);
    setIsSubscriptionRequired(false);
    setShowApplyCouponModal(showApplyCouponModal);
  }

  return (
    <>
      {showAccountModal && (
        <PaymentAccountModal
          onClose={closePaymentAccount}
          onSubmit={submitPaymentAccount}
          defaultMessage={true}
        />
      )}
      {
        isSubscriptionRequired && <ConfirmationAlert showFooter={false} showCloseIcon={true} handleConfirmAction={() => {
          setIsSubscriptionRequired(false);
          showApplyCouponModal(false);
        }}
          title={<>{ct("rta-trmc.dashboard.subscription.noSubscriptionMsg")} <span onClick={() => {
            handleSubscriptionDialog(false)
          }} className="hyperlink-text">{ct("rta-trmc.dashboard.subscription.buyNow")}</span> {ct("rta-trmc.dashboard.subscription.or")}  <span onClick={() => {
            handleSubscriptionDialog(true)
          }} className="hyperlink-text">{ct("rta-trmc.dashboard.subscription.enterCoupon")}.</span></>} />
      }
      {
        openSubscriptionModal && <ConfirmationAlert showFooter={false} showCloseIcon={true} handleConfirmAction={() => {
          setOpenSubscriptionModal(false);
          showApplyCouponModal(false);
        }}
          title={""}>
          <PackageList
            hideLogo={true}
            showPackageOnly={false}
            requestFrom="modal"
            closeSubscription={() => {
              setOpenSubscriptionModal(false);
              showApplyCouponModal(false);
            }}
            showApplyCouponModal={showApplyCouponModal}
          />
        </ConfirmationAlert>
      }
      <Grid
        container
        spacing={2}
        // sx={{
        //     padding: "20px"
        // }}

        className="payment-create-room"
      >
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <Stack spacing={2}>
            <TextField
              label={ct("rta-trmc.dashboard.myRoom.roomName")}
              name="room_name"
              variant="filled"
              disabled={!!paymentId}
              onChange={(e) => {
                if (startsWithNumber(e.target.value)) {
                  setErrors((oldErrors) => ({ ...oldErrors, room_name: ct("rta-trmc.dashboard.myRoom.roomNameError") }))
                } else {
                  handleInput(e);
                }
              }}
              inputProps={{ maxLength: 20 }}
              className="payment-input"
              value={formValue.room_name}
              error={
                errors.room_name && (!formValue.room_name.length || formValue?.room_name?.length < 3 || formValue?.room_name?.length > 25) ? true : false
              }
              helperText={
                errors.room_name && (!formValue.room_name.length || formValue?.room_name?.length < 3 || formValue?.room_name?.length > 25)
                  ? errors.room_name
                  : ""
              }
            />
          </Stack>
          <Paper
            elevation={0}
            component="div"
            className="create-room-label-Outerwrap"
            sx={{
              p: "2px 4px",
              mb: 2,
              mt: 2,
              display: "flex",
              alignItems: "center",
            }}
          >
            <Stack direction="row" spacing={2} className="private-wrap">
              <div className="private-toggle-wrap">
                <Typography className="create-room-label-wrap">{ct("rta-trmc.dashboard.myRoom.private")}</Typography>
                <Toggle
                  size="large"
                  testId="private-toggle"
                  id="private"
                  name="private"
                  onChange={handleInput}
                  isChecked={formValue.private ? true : false}
                />
              </div>
              {formValue.private && (
                <div className="d-flex password-wrap" style={{ alignItems: 'center' }}>
                  <Typography>{ct("rta-trmc.dashboard.myRoom.password")} : {formValue.password}</Typography>
                  <Tooltip title={ct("messages.tooltipCopyPassword", "messages")} arrow >
                    <i onClick={() => {
                      copyText(formValue.password);
                      dispatch(
                        setNotificationMessage({
                          isOpen: true,
                          type: NotificationType.SUCCESS,
                          message: ct("messages.copyPassword", "messages"),
                        })
                      );
                    }}
                      className="fa fa-clone theme-font-color ml-2" style={{ cursor: 'pointer' }} aria-hidden="true"></i>
                  </Tooltip>
                </div>
              )}
            </Stack>
          </Paper>

          <Paper
            elevation={0}
            component="div"
            className="create-room-label-Outerwrap"
            sx={{
              p: "2px 4px",
              mb: 2,
              mt: 2,
              display: "flex",
              alignItems: "center",
            }}
          >
            <Stack direction="row" spacing={1}>
              <Typography className="create-room-label-wrap">{ct("rta-trmc.dashboard.myRoom.publish")}</Typography>
              <Toggle
                size="large"
                testId="public-toggle"
                id="publish"
                name="publish"
                onChange={handleInput}
                isChecked={formValue.publish ? true : false}
              />
            </Stack>
          </Paper>
          {formValue.publish && (
            <>
              <FormControl
                variant="filled"
                className="payment-input room-category-select"
                sx={{
                  width: "100%",
                  fontSize: 16,
                  textAlign: "left",
                  // marginBottom: "20px",
                }}
                error={
                  errors.category && !formValue.category.length ? true : false
                }
              >
                <InputLabel id="select-standard-label" sx={{ fontSize: 16 }}>
                  {ct("rta-trmc.dashboard.myRoom.publish")}
                </InputLabel>
                <Select
                  labelId="select-standard-label"
                  id="select-standard"
                  value={filterString(formValue.category)}
                  onChange={handleInput}
                  label={ct("rta-trmc.dashboard.myRoom.publish")}
                  name="category"
                  sx={{ fontSize: 16 }}
                >
                  <MenuItem value="" sx={{ fontSize: 16 }}>
                    <em>{ct("rta-trmc.dashboard.myRoom.none")}</em>
                  </MenuItem>
                  {RoomCategory.map((item, index) => {
                    return (
                      <MenuItem key={index} value={item} sx={{ fontSize: 16 }}>
                        {ct("rta-trmc.dialogs." + item.toLowerCase())}
                      </MenuItem>
                    );
                  })}
                </Select>
                {errors.category && !formValue.category.length && (
                  <p className="Mui-error">{errors.category}</p>
                )}
              </FormControl>
            </>
          )}

          {/* paid lecture */}
          {getBaseConfig("paidLecture") == true && (
            <>
              <Paper
                elevation={0}
                component="div"
                className="create-room-label-Outerwrap"
                sx={{
                  p: "2px 4px",
                  mb: 2,
                  mt: 2,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Stack direction="row" spacing={1}>
                  <Typography className="create-room-label-wrap">{ct("rta-trmc.dashboard.myRoom.paid")}</Typography>
                  <Toggle
                    className="paid-toggle"
                    testId="paid-toggle"
                    size="large"
                    id="paid"
                    name="paid"
                    onChange={handleInput}
                    isChecked={formValue.paid ? true : false}
                    ref={paidRef}
                  />
                </Stack>
              </Paper>
              {
                connectAccount && connectApprovedFlash && <div className="payment-status-container-suc">
                  {ct("stripeMessage.paymentAccountApproved", "stripeMessage")}
                </div>
              }
              {formValue.paid && (
                <>
                  {<Stack spacing={2}>
                    <TextField
                      label={ct("rta-trmc.dashboard.myRoom.entranceFee")}
                      name="room_amount"
                      variant="filled"
                      onChange={(e) => {
                        let val = e.target.value;
                        const re = /^[0-9\b]+$/;
                        if (e.target.value === "" || re.test(val)) {
                          if (/^0/.test(val)) {
                            val = val.replace(/^0/, "");
                          }
                          if (val < stripeMessage.roomAmountMin) {
                            setErrors((oldErrors) => ({ ...oldErrors, room_amount: ct("stripeMessage.roomAmountLess", "stripeMessage") }))
                          } else if (val > stripeMessage.roomAmountMax) {
                            setErrors((oldErrors) => ({ ...oldErrors, room_amount: ct("stripeMessage.roomAmountGreat", "stripeMessage") }))
                          }
                          handleInput({
                            target: {
                              name: "room_amount",
                              value: val,
                            },
                          });
                        }
                      }}
                      inputProps={{ maxLength: 20 }}
                      className="payment-input"
                      value={formValue.room_amount}
                      error={
                        (errors.room_amount && (!formValue?.room_amount || formValue?.room_amount < stripeMessage.roomAmountMin || formValue?.room_amount > stripeMessage.roomAmountMax))
                          ? true
                          : false
                      }
                      helperText={
                        (errors.room_amount && (!formValue?.room_amount || formValue?.room_amount < stripeMessage.roomAmountMin || formValue?.room_amount > stripeMessage.roomAmountMax))
                          ? errors.room_amount
                          : ""
                      }
                    />
                  </Stack>}
                  <>{renderAccountView()}</>
                  {connectAccount &&
                    (connectAccountVerified == connectAccountFlag.FAILED ||
                      connectAccountVerified == connectAccountFlag.PENDING) && (
                      <span style={{ color: "black" }}>
                        {connectAccountVerified == connectAccountFlag.FAILED ? (
                          <div className="payment-status-container-fld">
                            <div>
                              <i className="fa fa-times"></i>
                            </div>
                            <div style={{ marginLeft: 10 }}>
                              <b>{ct("rta-trmc.dashboard.myRoom.error")}: </b>{" "}
                              {ct("stripeMessage.paymentAccountFailed", "stripeMessage")}{" "}
                              <span
                                style={{
                                  color: "var(--theme-primary-color)",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  handlePaidToggle(false, "update")
                                }
                              >{ct("rta-trmc.dashboard.myRoom.clickHere")}</span> {ct("rta-trmc.dashboard.myRoom.toUpdateAcc")}
                            </div>
                          </div>
                        ) : (
                          <div className="payment-status-container-prg">
                            {ct("stripeMessage.paymentAccountVerification", "stripeMessage")}
                          </div>
                        )}
                      </span>
                    )}
                </>
              )}
            </>
          )}

          <Grid container spacing={2} direction="row">
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              className="payment-room-date"
            >
              {/* <Paper
                                component="label"
                                sx={{
                                    p: '4px 6px',
                                    display: 'flex',
                                    alignItems: 'center'
                                }}
                            >
                                <DatePicker
                                    dateFormat="yyyy-MM-dd HH:mm"
                                    onChange={(date) => handleChangeDate({ startDate: date })}
                                    selected={formValue.startDate || new Date()}
                                    placeholderText={"Select Start date "}
                                    minDate={new Date()}
                                    showTimeSelect
                                />
                            </Paper>
                            {errors.startDate && !formValue?.startDate?.length ? <p className="Mui-error">{errors.startDate}</p> : null} */}
            </Grid>

            {/* <DropDownOptions
                            classes={{
                                container: "payment-room-timezone",
                                id: "payment-room-timezone"
                            }}
                            handleChange={handleInput}
                            children={
                                timezones.map((item, index) => {
                                    return <MenuItem key={index} value={item._id} sx={{ fontSize: 16 }}>{item.zone}</MenuItem>
                                })
                            }
                            label="Select timezone"
                            name="timezone"
                            value={formValue.timezone}
                        /> */}
          </Grid>

          <Grid container spacing={2} direction="row" className="recurring-outer">
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <FormControlLabel
                className="payment-recurring-meeting"
                control={
                  <Checkbox
                    checked={formValue.recurring}
                    onChange={() => {
                      setFormValue({
                        ...formValue,
                        recurring: !formValue.recurring,
                        recurrence_type: RoomOccurenceType.DAILY,
                        recurrence_interval: 1,
                      });
                    }}
                  />
                }
                label={ct('rta-trmc.dashboard.myRoom.recurringMeetingLabel')}
              />
            </Grid>
            {formValue.recurring && (
              <>
                <DropDownOptions
                  classes={{
                    container: "payment-room-repeat-type",
                    id: "recurrence-type",
                  }}
                  handleChange={handleChangeRecurrence}
                  children={Object.keys(RoomOccurenceType).map(
                    (item, index) => {
                      return (
                        <MenuItem
                          key={index}
                          value={item}
                          sx={{ fontSize: 16 }}
                        >
                          {getTranslatedInterval(RoomOccurenceType[item].toLowerCase())}
                        </MenuItem>
                      );
                    }
                  )}
                  label={ct("rta-trmc.dashboard.myRoom.roomName")}
                  name="recurrence_type"
                  value={formValue.recurrence_type}
                />

                <DropDownOptions
                  classes={{
                    container: "payment-room-repeat-days",
                    id: "recurrence-times",
                  }}
                  handleChange={handleChangeRecurrence}
                  children={RenderRecurrenceType(formValue.recurrence_type)}
                  label={ct("rta-trmc.dashboard.myRoom.repeatEvery") + printRecType()}
                  name="recurrence_interval"
                  value={formValue.recurrence_interval}
                />
                {formValue.recurrence_type == RoomOccurenceType.WEEKLY && (
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <InputLabel className="payment-recurring-meeting-title">
                      {ct("rta-trmc.dashboard.myRoom.occursOn")}
                    </InputLabel>
                    {RoomOccurenceWeekDays.map((item, index) => {
                      return (
                        <FormControlLabel
                          key={index}
                          className="payment-recurring-meeting"
                          control={
                            <Checkbox
                              onChange={handleWeekly}
                              disabled={
                                Object.keys(formValue.week_occurence).length ==
                                  1 && formValue?.week_occurence[item] == item
                                  ? true
                                  : false
                              }
                              checked={
                                formValue.week_occurence[item] != undefined
                                  ? true
                                  : false
                              }
                              name={item}
                            />
                          }
                          label={ct("rta-trmc.dashboard.weekDays." + item.toLowerCase())}
                        />
                      );
                    })}
                  </Grid>
                )}

                {formValue.recurrence_type == RoomOccurenceType.MONTHLY && (
                  <>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <InputLabel className="payment-recurring-meeting-title">
                        {ct("rta-trmc.dashboard.myRoom.occursOn")}
                      </InputLabel>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={12}
                      lg={6}
                      className="d-flex justify-content-between radioWrapper"
                    >
                      <Radio
                        checked={formValue.month_type == MonthType.ONCE}
                        name="month_days"
                        onChange={handleCheck}
                      />
                      <DropDownOptions
                        classes={{
                          container:
                            "payment-recurrence-m-days " +
                            (formValue.month_type == MonthType.MULTIPLE
                              ? "disabled-container"
                              : ""),
                          id: "recurrence-m-days",
                        }}
                        handleChange={handleChangeRecurrence}
                        children={RenderRecurrenceMDays()}
                        label={ct("rta-trmc.dashboard.myRoom.dayOfMonth")}
                        name="recurrence_m_days"
                        value={formValue.month_occurence.day}
                        noWrapper
                      // helperContent={}
                      // width="90%"
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      md={6}
                      lg={6}
                      className="d-flex justify-content-between radioWrapper"
                    >
                      <Radio
                        checked={formValue.month_type == MonthType.MULTIPLE}
                        name="month_weeks"
                        onChange={handleCheck}
                      />

                      <DropDownOptions
                        classes={{
                          container:
                            "payment-recurrence-user-days-on mr-4 " +
                            (formValue.month_type == MonthType.ONCE
                              ? "disabled-container"
                              : ""),
                          id: "recurrence-user-days-on",
                        }}
                        handleChange={handleChangeRecurrence}
                        children={Object.keys(WeekNumber).map((item, index) => {
                          return (
                            <MenuItem
                              key={index}
                              value={item}
                              sx={{ fontSize: 16 }}
                            >
                              {ct("rta-trmc.dashboard.weekNumber." + WeekNumber[item].toLowerCase())}
                            </MenuItem>
                          );
                        })}
                        label={ct("rta-trmc.dashboard.myRoom.onDay")}
                        name="recurrence_user-days-on"
                        value={filterOnWeek().key}
                        // helperContent={ }
                        noWrapper
                      // width="80%"
                      />
                      <DropDownOptions
                        classes={{
                          container:
                            "payment-recurrence-user-days-on " +
                            (formValue.month_type == MonthType.ONCE
                              ? "disabled-container"
                              : ""),
                          id: "recurrence-user-days-on-week",
                        }}
                        handleChange={handleChangeRecurrence}
                        children={Object.keys(WeekDayNames).map(
                          (item, index) => {
                            return (
                              <MenuItem
                                key={index}
                                value={item}
                                sx={{ fontSize: 16 }}
                              >
                                {ct("rta-trmc.dashboard.weeks." + WeekDayNames[item].toLowerCase())}
                              </MenuItem>
                            );
                          }
                        )}
                        label={ct("rta-trmc.dashboard.myRoom.onWeekDay")}
                        name="recurrence_user-days-on-week"
                        value={filterOnWeek().value}
                        noWrapper
                      />
                    </Grid>
                  </>
                )}

                {/* {userPaymentSubscription.end_at ? (
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <InputLabel className="payment-recurring-meeting-title">
                      Till date : {formatDate(userPaymentSubscription.end_at)}{" "}
                    </InputLabel>
                  </Grid>
                ) : null} */}
              </>
            )}
          </Grid>
        </Grid>

        <Grid item xs={12} sm={12} md={6} lg={6}>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            style={{
              marginBottom: "20px",
            }}
          >
            {/* {formValue.paid && connectAccountVerified===connectAccountFlag.APPROVED && ( */}
            <FormControl
              variant="filled"
              className={`custom-date-picker-wrapper payment-input ${isStartDateFocus
                ? "custom-date-picker-on-focus "
                : "custom-date-picker "
                } ${errors?.startDate && !formValue?.startDate
                  ? "custom-date-picker-error"
                  : ""
                }`}
              sx={{
                width: "100%",
                fontSize: 16,
                textAlign: "left",
                // marginBottom: "20px",
              }}
            // error={errors.startDate && !formValue.startDate ? true : false}
            >
              <InputLabel
                id="select-standard-label"
                sx={{ fontSize: 16 }}
                outlined="true"
                shrink={formValue?.startDate || isStartDateShrink}
                className={isStartDateFocus ? "custom-date-picker-label" : ""}
              >
                {ct("rta-trmc.dashboard.myRoom.startDateOpt")}
              </InputLabel>
              <DatePicker
                onFocus={() => handleOnFocusDate("startDate", "onFocus")}
                onBlur={() => handleOnFocusDate("startDate", "onBlur")}
                dateFormat="yyyy-MM-dd"
                onChange={(date) => handleChangeDate({ startDate: date })}
                selected={formValue.startDate}
                placeholderText={""}
                minDate={new Date()}
                locale={localeCalender()}
                isClearable={formValue.startDate ? true : false}
                clearButtonClassName="clear-calender-btn"
              />
            </FormControl>
            {/*  )} */}
            {errors.startDate && !formValue?.startDate ? (
              <p className="Mui-error">{errors.startDate}</p>
            ) : null}
            {/* <FormControl
                            variant="filled"
                            className="payment-input"
                            sx={{ width: "100%", fontSize: 16 }}
                        >
                            <InputLabel id="group_contact" sx={{ fontSize: 16 }}>Select Contact Group</InputLabel>
                            <Select
                                labelId="group_contact"
                                id="group_contact"
                                value={formValue?.invited_users?.group_id}
                                onChange={handleInput}
                                label="Select Contact Group"
                                name={"contact_group"}
                                sx={{ fontSize: 16 }}
                            >
                                <MenuItem value="" sx={{ fontSize: 16 }}>
                                    <em>None</em>
                                </MenuItem>
                                {
                                    groupList.map((e, i) => {
                                        return <MenuItem key={e._id} sx={{ fontSize: 16 }} value={e._id}>{e.group_name}
                                            {
                                                <em>{(" (contacts -" + e.contact_id.length + ")")}</em>
                                            }
                                        </MenuItem>
                                    })
                                }
                            </Select>
                        </FormControl> */}
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            style={{
              marginBottom: "20px",
            }}
          >
            {/* {formValue.paid && connectAccountVerified===connectAccountFlag.APPROVED && ( */}
            <FormControl
              variant="filled"
              className={`custom-date-picker-wrapper payment-input ${isEndDateFocus
                ? "custom-date-picker-on-focus"
                : "custom-date-picker"
                } ${errors?.endDate
                  ? "custom-date-picker-error"
                  : ""
                }`}
              sx={{
                width: "100%",
                fontSize: 16,
                textAlign: "left",
                // marginBottom: "20px",
              }}
              error={errors.endDate ? true : false}
            >
              <InputLabel
                id="select-standard-label"
                sx={{ fontSize: 16 }}
                outlined="true"
                shrink={formValue?.endDate || isEndDateShrink}
                className={isEndDateFocus ? "custom-date-picker-label" : ""}
              >
                {ct("rta-trmc.dashboard.myRoom.endDateOpt")}
              </InputLabel>
              <DatePicker
                onFocus={() => handleOnFocusDate("endDate", "onFocus")}
                onBlur={() => handleOnFocusDate("endDate", "onBlur")}
                dateFormat="yyyy-MM-dd"
                onChange={(date) => handleChangeDate({ endDate: date })}
                selected={formValue.endDate}
                minDate={new Date()}
                locale={localeCalender()}
                isClearable={formValue.endDate ? true : false}
                clearButtonClassName="clear-calender-btn"
              />
            </FormControl>
            {/* )} */}
            {errors.endDate ? (
              <p className="Mui-error">{errors.endDate}</p>
            ) : null}
          </Grid>
          {/* <Grid item xs={12} sm={12} md={12} lg={12}> */}
          {/* <Typography
                            sx={{
                                color: "#333"
                            }}
                        >
                            Select Contact(s)
                        </Typography>

                        <ContactAutoComplete
                            selectedEmail={selectedEmail}
                            existingUser={existingUser}
                        /> */}
          {/* <ContactDropMenu
                            selectedEmail={selectedEmail}
                            existingUser={existingUser}
                            removedEmail={handleRemovedEmail}
                            customStyle={{
                                mb: 3,
                                mt: 0,
                                width: "100%"
                            }}
                            width={"100%"}
                        /> */}
          {/* <DropDownOptions
                            classes={{
                                container: "payment-room-timezone",
                                id: "payment-room-timezone"
                            }}
                            handleChange={handleInput}
                            children={
                                timezones.map((item, index) => {
                                    return <MenuItem key={index} value={item._id} sx={{ fontSize: 16 }}>{item.zone}</MenuItem>
                                })
                            }
                            label="Select timezone"
                            name="timezone"
                            value={formValue.timezone}
                        /> */}
          {/* </Grid> */}
        </Grid>
      </Grid>
      <div className="createRoomButton">
        <Button
          className="create-btn-wrap"
          type="submit"
          onClick={() => handleFormSubmit()}
          variant="contained"
          sx={{
            fontSize: 14,
            backgroundColor: "var(--theme-primary-color)",
            "&:hover": {
              backgroundColor: "var(--theme-primary-color)",
            },
            mb: 2,
          }}
        >
          {ct("Translate.buttonTitle.submit")}
        </Button>
        {(isMobile || isTablet) &&
          <Button
            variant="outlined"
            className="cancel-button pull-right cancel-create-room"
            onClick={() => handleBack(false)}>
            {ct("Translate.buttonTitle.cancelSmall")}
          </Button>
        }
      </div>
    </>
  );
};

export default CreateRoom;
